export const closeDrawer = () =>{
    return{
        type:"CLOSEDRAWER"
    }
}
export const openDrawer = () =>{
    return{
        type:"OPENDRAWER"
    }
}